import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
// Import CSS files in the correct order
import "src/styles/index.css"; // Tailwind components and utilities
import "./i18n";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { arbitrum } from "@reown/appkit/networks";
import { createAppKit } from "@reown/appkit/react";
import { WagmiAdapter } from "@reown/appkit-adapter-wagmi";
import { WagmiProvider } from "wagmi";

import { App } from "./views/App";
import { app } from "./constants/configs";
import { BrowserRouter } from "react-router-dom";

const projectId = app.projectId || "Needs project ID";

// Check if the project ID is valid
if (projectId === "REPLACE_WITH_YOUR_PROJECT_ID") {
  console.warn(
    "⚠️ WalletConnect Project ID is not set. Please set VITE_WALLETCONNECT_PROJECT_ID in your .env file or update the projectId in src/constants/configs/app.tsx. Get your project ID from https://cloud.walletconnect.com/"
  );
}

// configs
const queryClient = new QueryClient();

const Root = () => {
  // Only initialize WalletConnect if we have a valid project ID
  const isValidProjectId = projectId !== "REPLACE_WITH_YOUR_PROJECT_ID";

  // Initialize WagmiAdapter only if we have a valid project ID
  const wagmiAdapter = isValidProjectId
    ? new WagmiAdapter({
        networks: [arbitrum],
        projectId,
      })
    : null;

  // Initialize AppKit only if we have a valid WagmiAdapter
  if (wagmiAdapter) {
    try {
      createAppKit({
        adapters: [wagmiAdapter],
        networks: [arbitrum],
        projectId,
        metadata: {
          name: app.name,
          description: app.description,
          url: app.appURL,
          icons: [app.onDark, app.onLight],
        },
        themeMode: "dark",
        featuredWalletIds: [
          "c57ca95b47569778a828d19178114f4db188b89b763c899ba0be274e97267d96", // Metamask
          "18388be9ac2d02726dbac9777c96efaac06d744b2f6d580fccdd4127a6d01fd1", // Rabby
          "fd20dc426fb37566d803205b19bbc1d4096b248ac04548e3cfb6b3a38bd033aa", // Coinbase
        ],
      });
    } catch (error) {
      console.error("Failed to initialize AppKit:", error);
    }
  }

  return (
    <StrictMode>
      <BrowserRouter>
        {wagmiAdapter ? (
          <WagmiProvider config={wagmiAdapter.wagmiConfig}>
            <QueryClientProvider client={queryClient}>
              <App />
            </QueryClientProvider>
          </WagmiProvider>
        ) : (
          // Fallback when WalletConnect is not configured
          <QueryClientProvider client={queryClient}>
            <App />
          </QueryClientProvider>
        )}
      </BrowserRouter>
    </StrictMode>
  );
};

createRoot(document.getElementById("root")!).render(<Root />);

export default Root;
